import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note15',
  templateUrl: './note15.component.html',
  styleUrls: ['./note15.component.scss'],
})
export class Note15Component implements OnInit {
  note15Form: FormGroup;
  calculativeDate: any;

  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note15) {
        this.calculativeDate = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes15(data.response.userInputData.data);
        }
      }
    });
  }
  editNotes15(res): void {
    this.note15Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
    });
  }

  setForm(): void {
    this.note15Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
